module.exports = function () {

    if ($('.featured-content-module').length === 0) {
        return;
    }    

    var updateLargeFeature = function (largeFeature) {
        var $largeFeature = $(largeFeature);

        if (!ICF.Utils.Breakpoints.IsAtLeastTablet()) {
            return;
        }

        var $largeFeatureTitle = $largeFeature.find('.featured-content-module__large-feature-title');

        if ($largeFeatureTitle.length) {
            var titleLineHeight = parseInt($largeFeatureTitle.css('line-height'), 10)
            if (!isNaN(titleLineHeight)) {
                var numLines = $largeFeatureTitle.innerHeight() / titleLineHeight
                if (typeof (numLines) == 'number') {

                    $largeFeature.removeClass('featured-content-module__large-feature--one-line-title');
                    $largeFeature.removeClass('featured-content-module__large-feature--two-line-title');
                    $largeFeature.removeClass('featured-content-module__large-feature--three-line-title');
                    $largeFeature.removeClass('featured-content-module__large-feature--four-line-title');
                    $largeFeature.removeClass('featured-content-module__large-feature--five-line-title');

                    if (numLines > 4) {                        
                        $largeFeature.addClass('featured-content-module__large-feature--five-line-title');
                    }
                    else if (numLines > 3) {                        
                        $largeFeature.addClass('featured-content-module__large-feature--four-line-title');
                    }
                    else if (numLines > 2) {                        
                        $largeFeature.addClass('featured-content-module__large-feature--three-line-title');
                    }
                    else if (numLines > 1) {                        
                        $largeFeature.addClass('featured-content-module__large-feature--two-line-title');
                    }
                    else if (numLines > 0) {                        
                        $largeFeature.addClass('featured-content-module__large-feature--one-line-title');
                    }                    
                }                
            }
        }    
    };

    $('.featured-content-module__large-feature').each(function () {
        updateLargeFeature(this);
    });

    $(window).resize(function () {
        $('.featured-content-module__large-feature').each(function () {
            updateLargeFeature(this);
        });
    });
};